// extracted by mini-css-extract-plugin
export default {"explainerItem":"AgreementAddAuthorizationModal_explainerItem__ygJvV"};